import React, { Component } from "react";
import { getDateString } from "../../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import "./UserMenu.css";

const DropdownItem = styled.div`
  padding: 5px 10px;
  &:hover {
    background-color: #f8f9fa;
  }
  a.dropdown-item {
    display: inline-block;
    width: 50%;
    padding-left: 2px;
    color: #777;
    &:active {
      background-color: #fff;
    }
  }
`;
class AppointmentDropdown extends Component {
  createLinks = (element, index) => {
    let tempTime = getDateString(element);
    return (
      <DropdownItem key={index}>
        <FontAwesomeIcon icon={faBullseye} />
        <a
          key={index}
          className="dropdown-item"
          href={`/app/instructor-dashboard/${element}`}
        >
          {`${tempTime.day} - ${tempTime.monthday}`}
        </a>
      </DropdownItem>
    );
  };
  render() {
    const { items } = this.props;
    return (
      <div className="dropdown-menu appointment-menu">
        {Object.keys(items).map(this.createLinks)}
      </div>
    );
  }
}

export default AppointmentDropdown;
